export default {
	pc: {
		chinese: {
			banner: require('@/images/product/2-1.png'),
			slidingList: [
				"金单",
				"供应链票据",
				"微贷",
				"信用评级",
				"票据秒融",
				"汇科云"
			],
			//金单
			jinBill: {
				title: '金单',
				desc: '可拆分、可流转的应收账款电子债权凭证',
				partnerImg: require('@/images/product/2-9.png'),
				paragraph: '【金单】是核心企业通过简单汇系统，以电子签名的方式，承诺在指定日期支付确定金额货款给供应商的，易流转、可拆分、秒融资、可追溯的应收账款债权凭证。经过多年打磨，简单汇已在多产业圈构建了智慧供应链金融服务体系，产业效益提升明显、供应链成本得到极大降低，金单商业模式已得到成功验证。',
				jindanList: [{
						iconPath: require("@/images/product/2-6.png"),
						title: "金单流转，普惠小微",
						desc: "供应商收到金单后，可根据需求进行拆转。目前，平台流转最远已达第9级供应商，金单流转最多涉及126家供应商。"
					},
					{
						iconPath: require("@/images/product/2-7.png"),
						title: "按需拆融，精打细算",
						desc: "供应商根据实际资金需求情况对金单进行拆分融资，可比不拆融大幅节省利息成本。"
					},
					{
						iconPath: require("@/images/product/2-8.png"),
						title: "智能匹配，多样融资",
						desc: "通过平台协助，供应商可结合自身实际需求，选择合作银行直连出资、保理公司应收款保理、供应链ABS储架模式等多种融资方式，优化现金管理、降低经营成本。"
					}
				],
				
			},
			//供应链票据
			supplyBill: {
				title: '供应链票据',
				desc: '全周期、一站式融资管理方案',
				paragraph: '【供应链票据】是企业通过供应链票据平台签发的票据。供应链票据平台依托于票交所建设运营的票据系统，由具有资质的供应链金融平台为企业提供供应链票据的签发、承兑、背书、融资、到期处理、信息服务全周期、一站式管理服务。供应链票据解决了传统票据无法实现拆分流转的难题，实现了核心企业信用的多级传导。供应链票据1分起开，自带贸易背景，金额可自由组合，能有效降低企业融资成本。',
				billList: [{
						iconPath: require("@/images/product/2-15.png"),
						desc: "供应链票据实现了等分化签发和流转，通过自由组合并运用开票金额，持票人可以灵活选择持有或贴现的金额。"
					},
					{
						iconPath: require("@/images/product/2-16.png"),
						desc: "供应链票据嵌入供应链收付款场景，将应收账款从源头上票据化，配合供应链票据平台，持票人可以更方便地办理已经标准化、规范化的供应链票据融资或转让，缓解资金紧张等问题。"
					}
				],
			},
			//金融平台
			financeImg: require('@/images/product/2-17.png'),
			//供应链票据+标准化票据组合
			chainBillAndStandardizedBill: {
				title: '供应链票据+标准化票据组合',
				paragraph: '【标准化票据】是指存托机构归集商业汇票组建基础资产池，以基础资产产生的现金流为偿付支持而创设的等分化受益凭证，通俗来讲是一种全新的、面向投资人募集资金来融资、不受制于银行授信额度的一种新的货币市场工具。企业在简单汇平台的帮助下完成线上签约及存托申请、协助存托机构归集、整理票据资产等内容，相对于传统商票具有融资成本低、资产限制少、发行效率高等优势。',
				capitalImg: require('@/images/product/2-19.png'),
			},
			//微贷
			wiCredit: {
				title: '微贷',
				desc: '依托大数据创新的中小微企业融资解决方案',
				paragraph: '【微贷】是简单汇基于产业知识图谱，深入分析产业机会，通过整合产业信息（IND）、小微企业信息（B）、企业主个人信息（C），发掘产业链上中小微企业自身的商业信用和金融信用能力，通过向中小微企业提供无抵押的纯信用线上融资服务，助力产业链协同发展。',
				guaranteeImg: require('@/images/product/2-28.png')
			},
			//信用评级
			credit: {
				title: '信用评级',
				desc: '恒诚信用评级——可靠高效的专业评级服务',
				paragraph: '【恒诚信用评级】是通过收集企业主体或金融产品的各类信息，依据不断优化的评级方法和模型，评价企业主体或债务的偿债能力和偿债意愿，用信用评级报告的形式发布评级结果。该评级结果可广泛应用于企业向金融机构申请各类融资，向政府机构申请享受各类优惠政策，向合作企业展示信用信息等。',
				flowImg: require('@/images/product/2-37.png'),
				//信用评级中文
				xypjList: [{
						iconPath: require("@/images/product/2-34.png"),
						title: "信用调查",
						desc: "采用背对背调查方式开展，通过本公司大数据库和电话访谈等方式获取信息来源。并通过定制化的企业评价模型给出目标企业信用等级，出具信用调查报告。"
					},
					{
						iconPath: require("@/images/product/2-35.png"),
						title: "信贷评级",
						desc: "以客户提供的资料、进场调查为主要信息获取方式，辅之以大数据库信息。"
					},
					{
						iconPath: require("@/images/product/2-36.png"),
						title: "智能评级",
						desc: "以客户线上提供的信息、授权获取的第三方信息及大数据库信息，通过系统评级模型自动进行信用评级并产生评级报告，通过系统接口传输结果给金融机构并定期更新评级数据。"
					}
				],
			},
			//票据秒融
			financing: {
				title: '票据秒融',
				desc: '票据询价、贴现、质押等信息技术服务',
				paragraph: `【票据秒融】是简单汇通过与合作银行的系统直连，为平台客户提供票据直贴、质押融资等线上综合信息技术服务的产品。持票企业可通过简单汇平台，一键
向多家银行发起在线询价，节省时间，降低融资成本，解决中小企业融资难、融资贵的问题。`,
				pjmrImg: require('@/images/product/2-44.png'),
				//票据秒融中文
				pjmrList: [{
						iconPath: require("@/images/product/2-41.png"),
						title: "秒级到账",
						desc: "一键询价，系统自动审批放款，真正实现秒级到账。"
					},
					{
						iconPath: require("@/images/product/2-42.png"),
						title: "操作简便",
						desc: "全流程线上操作，无需线下跑银行开户，高效便捷。"
					},
					{
						iconPath: require("@/images/product/2-43.png"),
						title: "实时报价",
						desc: "银行系统对接，报价实时更新，无平台服务费。"
					}
				],
			},
			//汇科云
			huikeCloud: {
				title: '汇科云',
				desc: '帮助企业构建“科技+金融”的能力',
				paragraph: '【汇科云】是科技赋能产品，以客户为中心，以服务为导向，发挥简单汇专业及服务优势，为客户提供全方位供应链金融科技服务，通过开放平台（品牌定制、单点登录、开放API、域名租赁）或本地部署等等方式，帮助企业构建“科技+金融”的能力，为客户实现供应链金融与科技的生态融合。',
				// 汇科云
				branchcloud: [{
						iconPath: require("@/images/product/2-49.png"),
						title: "产品标准、快速接入",
						desc: "开放平台（品牌定制、单点登录、开放API、域名租赁）接入流程标准化，最快1周上线，支持业务快速开展。"
					},
					{
						iconPath: require("@/images/product/2-50.png"),
						title: "定制开发、服务整合",
						desc: "本地部署支持内部系统集成与定制开发，帮助客户快速搭建自己的供应链金融平台，并提供专业技术、运营、客服、法务专业化咨询与系统培训支持，为客户快速、稳定开展业务报价护航。"
					}
        ],
        dataCenterTitle: '数据中心整体解决方案',
        dataCenterDesc: '提供标准化的“数据体系+数据应用”的数据中心解决方案，包括涵盖了“数据仓库+数据管理+数据全链路过程”的数据体系，以及囊括了“商业分析+管理驾驶舱+智能大屏”的数据应用。以体系支撑应用，以数据架起系统，数据中心整体解决方案能够快速实现企业的信息化、智能化。'
			}
		},
		english: {
			banner: require('@/images/english/banner_product.png'),
			slidingListYW: [
				"JinBill",
				"Supply chain bill",
				"WiCredit",
				"Credit rating Service",
				"Bill financing in seconds",
				"Huike Cloud"
			],
			//金单
			jinBill: {
				title: 'JinBill',
				desc: 'Splittable and circulated electronic creditor’s right certificate for accounts receivable',
				partnerImg:require('@/images/english/product_1.png'),
				paragraph: '【JinBill】is the creditor’s right certificate for accounts receivable that is easy to circulate, split, finance and trace. Based on the JinBill, the core enterprise promises to grant a certain amount of loans to suppliers on a specified date through the JDH system with electronic signature. With years of development, JDH has built a smart supply chain financial service system in multi-industry circles, substantially enhancing industrial benefits, greatly reducing supply chain costs, and successfully verifying the business model of JinBill.',
				jindanListYW: [{
						iconPath: require("@/images/product/2-6.png"),
						title: "JinBill circulates to benefit small and micro-sized enterprises",
						desc: "After being received by the supplier, the JinBill can be split and circulated according to the demand. At present, the platform circulation has even involved the Level 9 suppliers, and the JinBill circulation has involved 126 suppliers at most."
					},
					{
						iconPath: require("@/images/product/2-7.png"),
						title: "Splitting and financing on demand & saving interest costs",
						desc: "Suppliers can split and finance the JinBills according to their actual capital demand to greatly save the interest costs."
					},
					{
						iconPath: require("@/images/product/2-8.png"),
						title: "Intelligent matching & diversified financing",
						desc: "With the assistance of the JDH platform, suppliers can choose a variety of financing methods according to their actual demand, such as direct connection with cooperative banks for fund provision, receivables factoring by factoring companies, and Asset Backed Securities (ABS) refinancing mode of supply chain, to optimize cash management and reduce operating costs."
					}
				],
			},
			//供应链票据
			supplyBill: {
				title: 'Supply chain bill',
				desc: 'Full-cycle and one-stop financing management scheme',
				paragraph: `【Supply chain bill】refers to the bill issued by an enterprise through the supply chain bill platform. Relying on the bill system built and operated by Shanghai Commercial Paper Exchange Corporation Ltd., the qualified supply chain financial platform provides enterprises with full-cycle and one-stop management services for the issuance, acceptance, endorsement, financing, maturity processing and information service of supply chain bills. Supply chain bills have solved the problem that traditional bills can't be split and negotiated and thus realizing the multi-level credit transmission of the core enterprise. Besides, supply chain bills can be issued in the amount of 0.01 yuan. Based on different trade backgrounds, different amounts of supply chain bills can be freely formed to effectively reduce the financing costs of enterprises.`,
				billListYW: [{
						iconPath: require("@/images/product/2-15.png"),
						desc: "Supply chain bills have been issued and circulated in equal differentiation. The holders can flexibly choose the amount held or discounted by freely combining and using the invoiced amount."
					},
					{
						iconPath: require("@/images/product/2-16.png"),
						desc: "Supply chain bills are embedded in the collection and payment scenario of the supply chain, transforming accounts receivables into bills from the source. The holders can more easily handle the standardized and normalized supply chain bill financing or transfer by virtue of the supply chain bill platform, thus alleviating problems such as the shortage of funds."
					}
				],
			},
			//金融平台
			financeImg: require('@/images/english/product_2.png'),
			//供应链票据+标准化票据组合
			chainBillAndStandardizedBill: {
				title: 'Combination of supply chain bill + standardized bill',
				paragraph: '【Standardized bill】 refers to the equal differentiation beneficiary certificate initiated by depositary institutions by collecting commercial bills to form a basic asset pool and by taking the cash flow generated by basic assets as the repayment support. Generally speaking, it is a brand-new money market instrument that is open to investors to raise funds for financing and is not subject to the bank credit limit. Enterprises complete online signing and depositary application, and assist depositary institutions to collect and sort out bill assets with the help of the JDH platform. Compared with traditional commercial bills, standardized bills have the advantages of lower financing costs, fewer asset restrictions, higher issuance efficiency, etc.',
				capitalImg: require('@/images/english/product_3.png')
			},
			//微贷
			wiCredit: {
				title: 'WiCredit',
				desc: 'Financing solutions for MSMEs based on big data innovation',
				paragraph: `WiCredit aims to explore the commercial credit and financial credit capabilities of MSMEs in the industrial chain based on the industrial knowledge map, in-depth analysis of industrial opportunities, and integration of IND, small and micro enterprises information (B) and business owners' personal information (C), and promote the coordinated development of the industrial chain by providing online unsecured credit financing services to MSMEs.`,
				guaranteeImg: require('@/images/english/product_4.png')
			},
			//信用评级
			credit: {
				title: 'Credit rating Service',
				desc: 'Hengchangeng Credit Rating - Reliable and efficient professional rating service',
				paragraph: '[Hengcheng Credit Rating] is to evaluate the solvency and willingness to pay of corporate entities or debts by collecting various information of corporate entities or financial products,and based on continuously optimized rating methods and models, release ratings in the form of credit rating reports. The rating results can be widely used for enterprises to apply for various types of financing from finan-cial institutions and various preferential policies of government institutions , and also display credit information to cooperative enterprises.',
				flowImg: require('@/images/product/2-37-e.png'),
				//信用评级英文
				xypjListYW: [{
						iconPath: require("@/images/product/2-34.png"),
						title: "Credit investigation",
						desc: "It is carried out by way of back-to-back investigation,and information sources are obtained through the company's large database and telephone interviews.Through the customized enterprise evaluation model,the target enterprise's credit rating is given,,and a credit investigation report is issued."
					},
					{
						iconPath: require("@/images/product/2-35.png"),
						title: "Credit rating",
						desc: "The main information acquisition method is based on the information provided by customers andon-site investigation,supplemented by large data-base information.The target enterprise is given acredit rating through a customized enterprise evalua-tion model,and a standardized credit rating report isissued."
					},
					{
						iconPath: require("@/images/product/2-36.png"),
						title: "Intelligent rating",
						desc: "Based on the information provided by customersonline,authorized third-party information and largedatabase information,the system rating model isused to automatically perform credit rating andgenerate rating reports,the results are transmitted tofinancial institutions through the system interfaceand the rating data is regularly updated."
					}
				],
			},
			//票据秒融
			financing: {
				title: 'Bill financing in seconds',
				desc: 'Bill inquiry,discount,pledge and other information technology services.',
				paragraph: '[Bill Financing] is a product that JDH provides platform customers with online compre-hensive services such as bill direct discounting and pledge financing through the systemdirectly connected to the cooperative bank.Bill holders can initiate online inquiries tomultiple banks with one click through the JDH platform.saving time.reducing financingcosts.and solving the problems of dfficult and expensive financing for SME.',
				pjmrImg: require('@/images/product/pjmr-e.png'),
				//票据秒融英文
				pjmrListYW: [{
						iconPath: require("@/images/product/2-41.png"),
						title: "Account in seconds",
						desc: "One-click inquiry,the system automati-cally approves the loan,and truly real-izes loan to the account in seconds."
					},
					{
						iconPath: require("@/images/product/2-42.png"),
						title: "Easy to operate",
						desc: "The whole process is operated online,and there is no need to go offline to open a bank account,which is efficient and convenient."
					},
					{
						iconPath: require("@/images/product/2-43.png"),
						title: "Real-time quotes",
						desc: "Docking with banking systems,quotations are updated in real time,OCR bills recogni-tion is supported,and free quotation."
					}
				],
			},
			//汇科云
			huikeCloud: {
				title: 'Huike cloud',
				desc: `Help enterprises to build the ability of “Technology + Finance”.`,
				paragraph: `【Huike Cloud】is a technology-enabled product that is customer-centric and service-ori-ented,giving full play to its professional and service advantages to provide customers witha full range of supply chain financial technology services. Through open platforms (brandcustomization, single sign-on, open API, domain name leasing) or local deployment, etc., to help enterprisesbuild the ability of 'Technology + Finance', and realize the ecological integration of supplychain finance and technology for customers.`,
				// 汇科云英文
				branchcloudYW: [{
						iconPath: require("@/images/product/2-49.png"),
						title: "Product standard, quick access",
						desc: "The open platform (brand customization, single sign-on, open API, domain name leasing) accessprocess is standardized, and it can be launched in one week at the fastest,supporting rapid business development."
					},
					{
						iconPath: require("@/images/product/2-50.png"),
						title: "Custom development, service integration",
						desc: "Local deployment supports internal system integration and customized develop-ment, helps customers quickly build their own supply chain financial platform, andprovides professional technical, operation, customer service, and legal professionalconsulting and training support to ensure rapid and stable business development forcustomers."
					}
        ],
        dataCenterTitle: 'The Overall Solution of Data Center',
        dataCenterDesc: 'Provide a standardized "data system+data application" data center solution, including a data system covering "data warehouse+data management+full data link process", as well as a data application covering "business intelligent analysis+management cockpit+intelligent Monitoring large screen". Supporting applications with Data Center and building systems with Data Center, the overall solution of data centers can quickly achieve enterprise informatization and intelligence.'
			}
		}
	},
	phone: {
		chinese: {
			banner: require('@/images/mobile/product/1-0.png'),
			slidingList: [
				"金单",
				"供应链票据",
				"微贷",
				"信用评级",
				"票据秒融",
				"汇科云"
			],
			//金单
			jinBill: {
				title: '金单',
				desc: '可拆分、可流转的应收账款电子债权凭证',
				partnerImg:require('@/images/mobile/product/1-6.png'),
				paragraph: '【金单】是核心企业通过简单汇系统，以电子签名的方式，承诺在指定日期支付确定金额货款给供应商的，易流转、可拆分、秒融资、可追溯的应收账款债权凭证。经过多年打磨，简单汇已在多产业圈构建了智慧供应链金融服务体系，产业效益提升明显、供应链成本得到极大降低，金单商业模式已得到成功验证。',
				jindanList: [{
						iconPath: require("@/images/mobile/product/1-2.png"),
						title: "金单流转，普惠小微",
						desc: "供应商收到金单后，可根据需求进行拆转。目前，平台流转最远已达第9级供应商，金单流转最多涉及126家供应商。"
					},
					{
						iconPath: require("@/images/mobile/product/1-3.png"),
						title: "按需拆融，精打细算",
						desc: "供应商根据实际资金需求情况对金单进行拆分融资，可比不拆融大幅节省利息成本。"
					},
					{
						iconPath: require("@/images/mobile/product/1-4.png"),
						title: "智能匹配，多样融资",
						desc: "通过平台协助，供应商可结合自身实际需求，选择合作银行直连出资、保理公司应收款保理、供应链ABS储架模式等多种融资方式，优化现金管理、降低经营成本。"
					}
				],
			},
			//供应链票据
			supplyBill: {
				title: '供应链票据',
				desc: '全周期、一站式融资管理方案',
				paragraph: '【供应链票据】是企业通过供应链票据平台签发的票据。供应链票据平台依托于票交所建设运营的票据系统，由具有资质的供应链金融平台为企业提供供应链票据的签发、承兑、背书、融资、到期处理、信息服务全周期、一站式管理服务。供应链票据解决了传统票据无法实现拆分流转的难题，实现了核心企业信用的多级传导。供应链票据1分起开，自带贸易背景，金额可自由组合，能有效降低企业融资成本。',
				billList: [{
						iconPath: require("@/images/product/2-15.png"),
						desc: "供应链票据实现了等分化签发和流转，通过自由组合并运用开票金额，持票人可以灵活选择持有或贴现的金额。"
					},
					{
						iconPath: require("@/images/product/2-16.png"),
						desc: "供应链票据嵌入供应链收付款场景，将应收账款从源头上票据化，配合供应链票据平台，持票人可以更方便地办理已经标准化、规范化的供应链票据融资或转让，缓解资金紧张等问题。"
					}
				],
			},
			//金融平台
			financeImg: require('@/images/mobile/product/1-7.png'),
			//供应链票据+标准化票据组合
			chainBillAndStandardizedBill: {
				title: '供应链票据+标准化票据组合',
				paragraph: '【标准化票据】是指存托机构归集商业汇票组建基础资产池，以基础资产产生的现金流为偿付支持而创设的等分化受益凭证，通俗来讲是一种全新的、面向投资人募集资金来融资、不受制于银行授信额度的一种新的货币市场工具。企业在简单汇平台的帮助下完成线上签约及存托申请、协助存托机构归集、整理票据资产等内容，相对于传统商票具有融资成本低、资产限制少、发行效率高等优势。',
				capitalImg: require('@/images/mobile/product/1-8.png'),
			},
			//微贷
			wiCredit: {
				title: '微贷',
				desc: '依托大数据创新的中小微企业融资解决方案',
				paragraph: '【微贷】是简单汇基于产业知识图谱，深入分析产业机会，通过整合产业信息（IND）、小微企业信息（B）、企业主个人信息（C），发掘产业链上中小微企业自身的商业信用和金融信用能力，通过向中小微企业提供无抵押的纯信用线上融资服务，助力产业链协同发展。',
				guaranteeImg: require('@/images/mobile/product/1-9.png')
			},
			//信用评级
			credit: {
				title: '信用评级',
				desc: '恒诚信用评级——可靠高效的专业评级服务',
				paragraph: '【恒诚信用评级】是通过收集企业主体或金融产品的各类信息，依据不断优化的评级方法和模型，评价企业主体或债务的偿债能力和偿债意愿，用信用评级报告的形式发布评级结果。该评级结果可广泛应用于企业向金融机构申请各类融资，向政府机构申请享受各类优惠政策，向合作企业展示信用信息等。',
				flowImg: require('@/images/mobile/product/pjlc-z.png'),
				//信用评级中文
				xypjList: [{
						title:'信用调查',
						iconPath: require("@/images/mobile/product/xypj-1.png"),
						desc: "采用背对背调查方式开展，通过本公司大数据库和电话访谈等方式获取信息来源。并通过定制化的企业评价模型给出目标企业信用等级，出具信用调查报告。"
					},
					{
						title:'信贷评级',
						iconPath: require("@/images/mobile/product/xypj-2.png"),
						desc: "以客户提供的资料、进场调查为主要信息获取方式，辅之以大数据库信息。"
					},
					{
						title:'智能评级',
						iconPath: require("@/images/mobile/product/xypj-3.png"),
						desc: "以客户线上提供的信息、授权获取的第三方信息及大数据库信息，通过系统评级模型自动进行信用评级并产生评级报告，通过系统接口传输结果给金融机构并定期更新评级数据。"
					}
				],
			},
			//票据秒融
			financing: {
				title: '票据秒融',
				desc: '票据询价、贴现、质押等信息技术服务',
				paragraph: `【票据秒融】是简单汇通过与合作银行的系统直连，为平台客户提供票据直贴、质押融资等线上综合信息技术服务的产品。持票企业可通过简单汇平台，一键
		向多家银行发起在线询价，节省时间，降低融资成本，解决中小企业融资难、融资贵的问题。`,
				pjmrImg: require('@/images/mobile/product/pjmr-lct-z.png'),
				//票据秒融中文
				pjmrList: [{
						title:'秒级到账',
						iconPath: require("@/images/mobile/product/pjmr-01.png"),
						desc: "一键询价，系统自动审批放款，真正实现秒级到账。"
					},
					{
						title:'操作简便',
						iconPath: require("@/images/mobile/product/pjmr-02.png"),
						desc: "全流程线上操作，无需线下跑银行开户，高效便捷。"
					},
					{
						title:'实时报价',
						iconPath: require("@/images/mobile/product/pjmr-03.png"),
						desc: "银行系统对接，报价实时更新，无平台服务费。"
					}
				],
			},
			//汇科云
			huikeCloud: {
				title: '汇科云',
				desc: '帮助企业构建“科技+金融”的能力',
				paragraph: '【汇科云】是科技赋能产品，以客户为中心，以服务为导向，发挥简单汇专业及服务优势，为客户提供全方位供应链金融科技服务，通过开放平台（品牌定制、单点登录、开放API、域名租赁）或本地部署等等方式，帮助企业构建“科技+金融”的能力，为客户实现供应链金融与科技的生态融合。',
				// 汇科云
				branchcloud: [{
						iconPath: require("@/images/mobile/product/hky-01.png"),
						title: "产品标准、快速接入",
						desc: "开放平台（品牌定制、单点登录、开放API、域名租赁）接入流程标准化，最快1周上线，支持业务快速开展。"
					},
					{
						iconPath: require("@/images/mobile/product/hky-02.png"),
						title: "定制开发、服务整合",
						desc: "本地部署支持内部系统集成与定制开发，帮助客户快速搭建自己的供应链金融平台，并提供专业技术、运营、客服、法务专业化咨询与培训支持，为客户快速、稳定开展业务保驾护航。"
					},
					{
						iconPath: require("@/images/product/2-51.png"),
						title: "数据中心整体解决方案",
						desc: "提供标准化的“数据体系+数据应用”的数据中心解决方案，包括涵盖了“数据仓库+数据管理+数据全链路过程”的数据体系，以及囊括了“商业分析+管理驾驶舱+智能大屏”的数据应用。以体系支撑应用，以数据架起系统，数据中心整体解决方案能够快速实现企业的信息化、智能化。"
					}
				]
			}
		},
		english: {
			banner:require('@/images/mobile/english/banner_product.png'),
			slidingListYW: [
				"JinBill",
				"Supply chain bill",
				"WiCredit",
				"Credit rating Service",
				"Bill financing in seconds",
				"Huike Cloud"
			],
			//金单
			jinBill: {
				title: 'JinBill',
				desc: 'Splittable and circulated electronic creditor’s right certificate for accounts receivable',
				partnerImg:require('@/images/mobile/english/product_1.png'),
				paragraph: '【JinBill】is the creditor’s right certificate for accounts receivable that is easy to circulate, split, finance and trace. Based on the JinBill, the core enterprise promises to grant a certain amount of loans to suppliers on a specified date through the JDH system with electronic signature. With years of development, JDH has built a smart supply chain financial service system in multi-industry circles, substantially enhancing industrial benefits, greatly reducing supply chain costs, and successfully verifying the business model of JinBill.',
				jindanListYW: [{
						iconPath: require("@/images/mobile/product/1-2.png"),
						title: "JinBill circulates to benefit small and micro-sized enterprises",
						desc: "After being received by the supplier, the JinBill can be split and circulated according to the demand. At present, the platform circulation has even involved the Level 9 suppliers, and the JinBill circulation has involved 126 suppliers at most."
					},
					{
						iconPath: require("@/images/mobile/product/1-3.png"),
						title: "Splitting and financing on demand & saving interest costs",
						desc: "Suppliers can split and finance the JinBills according to their actual capital demand to greatly save the interest costs."
					},
					{
						iconPath: require("@/images/mobile/product/1-4.png"),
						title: "Intelligent matching & diversified financing",
						desc: "With the assistance of the JDH platform, suppliers can choose a variety of financing methods according to their actual demand, such as direct connection with cooperative banks for fund provision, receivables factoring by factoring companies, and Asset Backed Securities (ABS) refinancing mode of supply chain, to optimize cash management and reduce operating costs."
					}
				],
			},
			//供应链票据
			supplyBill: {
				title: 'Supply chain bill',
				desc: 'Full-cycle and one-stop financing management scheme',
				paragraph: `【Supply chain bill】refers to the bill issued by an enterprise through the supply chain bill platform. Relying on the bill system built and operated by Shanghai Commercial Paper Exchange Corporation Ltd., the qualified supply chain financial platform provides enterprises with full-cycle and one-stop management services for the issuance, acceptance, endorsement, financing, maturity processing and information service of supply chain bills. Supply chain bills have solved the problem that traditional bills can't be split and negotiated and thus realizing the multi-level credit transmission of the core enterprise. Besides, supply chain bills can be issued in the amount of 0.01 yuan. Based on different trade backgrounds, different amounts of supply chain bills can be freely formed to effectively reduce the financing costs of enterprises.`,
				billListYW: [{
						iconPath: require("@/images/product/2-15.png"),
						desc: "Supply chain bills have been issued and circulated in equal differentiation. The holders can flexibly choose the amount held or discounted by freely combining and using the invoiced amount."
					},
					{
						iconPath: require("@/images/product/2-16.png"),
						desc: "Supply chain bills are embedded in the collection and payment scenario of the supply chain, transforming accounts receivables into bills from the source. The holders can more easily handle the standardized and normalized supply chain bill financing or transfer by virtue of the supply chain bill platform, thus alleviating problems such as the shortage of funds."
					}
				],
			},
			//金融平台
			financeImg: require('@/images/mobile/english/product_2.png'),
			//供应链票据+标准化票据组合
			chainBillAndStandardizedBill: {
				title: 'Combination of supply chain bill + standardized bill',
				paragraph: '【Standardized bill】 refers to the equal differentiation beneficiary certificate initiated by depositary institutions by collecting commercial bills to form a basic asset pool and by taking the cash flow generated by basic assets as the repayment support. Generally speaking, it is a brand-new money market instrument that is open to investors to raise funds for financing and is not subject to the bank credit limit. Enterprises complete online signing and depositary application, and assist depositary institutions to collect and sort out bill assets with the help of the JDH platform. Compared with traditional commercial bills, standardized bills have the advantages of lower financing costs, fewer asset restrictions, higher issuance efficiency, etc.',
				capitalImg: require('@/images/mobile/english/product_3.png')
			},
			//微贷
			wiCredit: {
				title: 'WiCredit',
				desc: 'Financing solutions for MSMEs based on big data innovation',
				paragraph: `WiCredit aims to explore the commercial credit and financial credit capabilities of MSMEs in the industrial chain based on the industrial knowledge map, in-depth analysis of industrial opportunities, and integration of IND, small and micro enterprises information (B) and business owners' personal information (C), and promote the coordinated development of the industrial chain by providing online unsecured credit financing services to MSMEs.`,
				guaranteeImg: require('@/images/mobile/english/product_4.png')
			},
			//信用评级
			credit: {
				title: 'Credit rating Service',
				desc: 'Hengchangeng Credit Rating - Reliable and efficient professional rating service',
				paragraph: '[Hengcheng Credit Rating] is to evaluate the solvency and willingness to pay of corporate entities or debts by collecting various information of corporate entities or financial products,and based on continuously optimized rating methods and models, release ratings in the form of credit rating reports. The rating results can be widely used for enterprises to apply for various types of financing from finan-cial institutions and various preferential policies of government institutions , and also display credit information to cooperative enterprises.',
				flowImg: require('@/images/mobile/english/pjlc-e.png'),
				//信用评级英文
				xypjListYW: [{
						title:'Credit investigation',
						iconPath:require("@/images/mobile/product/xypj-1.png"),
						desc: "It is carried out by way of back-to-back investigation, and information sources are obtained through the company's large database and telephone interviews. Through the customized enterprise evaluation model, the target enterprise's credit rating is given, and a credit investigation report is issued. "
					},
					{
						title:'Credit rating',
						iconPath: require("@/images/mobile/product/xypj-2.png"),
						desc: "The main information acquisition method is based on the information provided by customers and on-site investigation, supplemented by large database information. The target enterprise is given a credit rating through a customized enterprise evaluation model, and a standardized credit rating report is issued. "
					},
					{
						title:'Intelligent rating',
						iconPath:  require("@/images/mobile/product/xypj-3.png"),
						desc: "Based on the information provided by customers online, authorized third-party information and large database information, the system rating model is used to automatically perform credit rating and generate rating reports, the results are transmitted to financial institutions through the system interface and the rating data is regularly updated."
					}
				],
			},
			//票据秒融
			financing: {
				title: 'Bill financing in seconds',
				desc: 'Bill inquiry,discount,pledge and other information technology services.',
				paragraph: '[Bill Financing] is a product that JDH provides platform customers with online compre-hensive services such as bill direct discounting and pledge financing through the systemdirectly connected to the cooperative bank.Bill holders can initiate online inquiries tomultiple banks with one click through the JDH platform.saving time.reducing financingcosts.and solving the problems of dfficult and expensive financing for SME.',
				pjmrImg: require('@/images/mobile/english/pjmr-lct-e.png'),
				//票据秒融英文
				pjmrListYW: [{
						title:'Account in seconds',
						iconPath: require("@/images/mobile/product/pjmr-01.png"),
						desc: "One-click inquiry, the system automatically approves the loan, and truly realizes loan to the account in seconds."
					},
					{
						title:'Easy to operate',
						iconPath: require("@/images/mobile/product/pjmr-02.png"),
						desc: "The whole process is operated online, and there is no need to go offline to open a bank account, which is efficient and convenient."
					},
					{
						title:'Real-time quotes',
						iconPath: require("@/images/mobile/product/pjmr-03.png"),
						desc: "Docking with banking systems, quotations are updated in real time, OCR bills recognition is supported, and free quotation."
					}
				],
			},
			//汇科云
			huikeCloud: {
				title: 'Huike cloud',
				desc: `Help enterprises to build the ability of “Technology + Finance”.`,
				paragraph: `【Huike Cloud】is a technology-enabled product that is customer-centric and service-ori-ented,giving full play to its professional and service advantages to provide customers witha full range of supply chain financial technology services. Through open platforms (brandcustomization, single sign-on, open API, domain name leasing) or local deployment, etc., to help enterprisesbuild the ability of 'Technology + Finance', and realize the ecological integration of supplychain finance and technology for customers.`,
				// 汇科云英文
				branchcloudYW: [{
						iconPath: require("@/images/mobile/product/hky-01.png"),
						title: "Product standard, quick access",
						desc: "The open platform (brand customization, single sign-on, open API, domain name leasing) access process is standardized, and it can be launched in one week at the fastest, supporting rapid business development."
					},
					{
						iconPath: require("@/images/mobile/product/hky-02.png"),
						title: "Customized development,service integration",
						desc: `Local deployment supports internal system integration and customized development, helps customers quickly build their own supply chain financial platform, and provides professional technical, operation, customer service, and legal professional consulting and training support to ensure rapid and stable business development for customers.`
					},
					{
						iconPath: require("@/images/product/2-51.png"),
						title: "The Overall Solution of Data Center",
						desc: `Provide a standardized "data system+data application" data center solution, including a data system covering "data warehouse+data management+full data link process", as well as a data application covering "business intelligent analysis+management cockpit+intelligent Monitoring large screen". Supporting applications with Data Center and building systems with Data Center, the overall solution of data centers can quickly achieve enterprise informatization and intelligence.`
					}
        ]
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/utils/lang/product.js